export default function Input() {
  return (
    <input
      className="w-full rounded-lg border-2 border-gray-500 bg-gray-200 px-4 py-2 text-black outline-none dark:border-dark-500 dark:bg-dark-200"
      disabled
    />
  );
}
